// extracted by mini-css-extract-plugin
export default {"root":"TabMenu_root__DBK-f","item":"TabMenu_item__1WUdd","active":"TabMenu_active__Zp3rN","container":"TabMenu_container__XDSsQ","actionWrapper":"TabMenu_actionWrapper__A0n1I"};